// @ts-nocheck


import normalizeUrl from 'normalize-url';
import { proxyApi } from './../../api';
import qs from 'query-string';
import _isEmpty from 'lodash/isEmpty';

export type WialonResponse = Record<string, unknown>;

export type WialonApiSection = {
  fetch: (path: string, body?: unknown) => Promise<WialonResponse>;
  path: (svc: string | null, root: string, params: string) => string;
};

export default class RequestsController {
  host: string;
  accessToken: string | null;
  sid?: string;
  avlInterval?: ReturnType<typeof setInterval>;
  loginPromise?: Promise<void>;
  generation = 0;
  closed = false;





  constructor(host: string, accessToken: string | null) {
    this.host = host;
    this.accessToken = accessToken;
  }

  /**
   * Аутентификация внутри виалона и активация avl_evts счетчика
   * @returns {Promise<void>}
   */
  async login() {
    if (this.closed) {
      throw new Error('Wialon controller is closed');
    }

    if (this.loginPromise) return this.loginPromise;
    if (this.sid && this.avlInterval) return;

    const generation = this.generation;
    const loginPromise = (async () => {
      const response = await this.fetch('token/login', {
        token: this.accessToken
      });

      if (this.closed || generation !== this.generation) return;

      this.sid = typeof response.eid === 'string' ? response.eid : undefined;
      clearInterval(this.avlInterval);
      this.avlInterval = setInterval(() => {
        if (this.closed || generation !== this.generation) return;
        void this.fetch(null, null, '/avl_evts').catch(() => undefined);
      }, 1000);
    })();

    this.loginPromise = loginPromise;
    try {
      await loginPromise;
    } finally {
      if (this.loginPromise === loginPromise) this.loginPromise = undefined;
    }
  }

  /**
   * Прекращение запроса событий
   */
  async logout() {
    this.generation += 1;
    clearInterval(this.avlInterval);
    this.avlInterval = undefined;
    this.sid = undefined;
    this.loginPromise = undefined;
  }

  async destroy() {
    await this.logout();
    this.closed = true;
    this.accessToken = null;
  }

  /**
   * Функция для отправки запросов к виалону
   * @param svc Идентификатор команды. Например, user/update_auth_params
   * @param params Параметры запроса
   * @param root Корень пути запроса
   */
  async fetch(
    svc: string | null,
    params: unknown,
    root = 'wialon/ajax.html'
  ): Promise<WialonResponse> {
    if (this.closed) {
      throw new Error('Wialon controller is closed');
    }

    const formData = params ? new URLSearchParams() : undefined;
    if (this.sid && formData) {
      formData.append('sid', this.sid);
    }
    if (params && formData) {
      formData.append('params', JSON.stringify(params));
    }
    const url = this._path(svc, root, JSON.stringify(params));
    return proxyApi.proxy(url);
  }

  async request(svc: string | null, params: unknown) {
    return await this.fetch(svc, params);
  }

  /**
   * Функция нормализации пути запроса
   * @param svc Идентификатор команды
   * @param root Корень пути
   * @param params Параметры query-string
   */
  _path = (svc: string | null, root: string, params: string) => {
    const queryParams = { svc, sid: this.sid, params };
    const queryString = _isEmpty(queryParams) ?
    '' :
    `${qs.stringify(queryParams, { strict: false, skipNull: true })}`;
    return normalizeUrl(`${this.host}/${root}?${queryString}`);
  };

  /**
   * Создание API секции для удобства документирования api виалона в коде
   * @param sectionName Название секции в Виалон API. Например, unit
   */
  getApiSection = (sectionName: string): WialonApiSection => {
    return {
      fetch: async (path, body) =>
      await this.fetch(`${sectionName}/${path}`, body),
      path: this._path
    };
  };
}
